import { combineReducers } from 'redux';
import customization from '../store/customizationReducer';
import skanRateCardStoreReducer from './skanRateCardStore/skanRateCardStoreReducer';
import advertiserReducer from './advertiser/advertiserReducer';
import campaignReducer from './campaign/campaignReducer';
import userReducer from './user/userReducer';
import reportingReducer from './reporting/reportingReducer';
import creativeReducer from './creative/creativeReducer';
import sidebarReducer from './sidebar/sidebarReducer';
import rawEventReducer from './rawEvent/rawEventReducer';
import stateReportReducer from './stateReport/stateReportReducer';
import wowReducer from './wow/wowReducer';
import IAPReducer from './iap/iapReducer';
import dodReducer from './dod/dodReducer';
import mailerReducer from './mailerlist/mailerReducer';
import d2cReducer from './d2c/d2cReducers';
import ctvReducer from './ctv/ctvReducers';
import gtvReducer from './gtv/gtvReducers';
const reducer = combineReducers({
  customization,
  skanRateCardStoreReducer,
  advertiserReducer,
  campaignReducer,
  userReducer,
  reportingReducer,
  creativeReducer,
  sidebarReducer,
  rawEventReducer,
  stateReportReducer,
  wowReducer,
  IAPReducer,
  dodReducer,
  mailerReducer,
  d2cReducer,
  ctvReducer,
  gtvReducer
});

export default reducer;
